import { create } from "zustand";

type container =
  | "cask"
  | "keg"
  | "can"
  | "bottle"
  | "bag"
  | "pouch"
  | "bagInBox";

type PreOrderFilterState = {
  selectedMonth: Date | null;
  months: Date[];
  selectedCategoryType: string;
  selectedContainerTypes: container[];
  setSelectedMonth: (month: Date | null) => void;
  setMonths: (months: Date[]) => void;
  addContainerType: (type: container) => void;
  removeContainerType: (type: container) => void;
  toggleContainerType: (type: container) => void;
  setContainerTypes: (types: container[]) => void;
  clearContainerTypes: () => void;
  setCategoryType: (category: string) => void;
};

export const useDiscoveryV2PreOrderStore = create<PreOrderFilterState>(
  (set) => ({
    selectedMonth: null,
    months: [],
    selectedCategoryType: "all",
    selectedContainerTypes: [],
    setSelectedMonth: (month) => set({ selectedMonth: month }),
    setMonths: (months) => set({ months }),
    addContainerType: (type) =>
      set((state) => ({
        selectedContainerTypes: [...state.selectedContainerTypes, type],
      })),
    removeContainerType: (type) =>
      set((state) => ({
        selectedContainerTypes: state.selectedContainerTypes.filter(
          (t) => t !== type,
        ),
      })),
    toggleContainerType: (type) =>
      set((state) => ({
        selectedContainerTypes: state.selectedContainerTypes.includes(type)
          ? state.selectedContainerTypes.filter((t) => t !== type)
          : [...state.selectedContainerTypes, type],
      })),
    setContainerTypes: (types) => set({ selectedContainerTypes: types }),
    clearContainerTypes: () => set({ selectedContainerTypes: [] }),
    setCategoryType: (category) => set({ selectedCategoryType: category }),
  }),
);
